import { useHeaderStore } from "@/store/header.ts";
import { onIonViewWillEnter, onIonViewWillLeave } from "@ionic/vue";
import { HeaderDefinition } from "@movinglayers/navigation";
import { ref } from "vue";

/** 
    * This composable is used to update the header meta info of the current view.
    * The composable handles the lifecycle issues of each view and updates the store that holds the centralized state.
    * @param newHeaderInfo The new header information to be set.
    * @returns { updateHeaderTitle } A function to update the header title when the view is active.
    */

export default (newHeaderInfo: HeaderDefinition) => {
    const headerStore = useHeaderStore();
    const isViewActive = ref(false);

    const setHeader = () => {
        headerStore.setHeaderDefinition(newHeaderInfo);
    };

    onIonViewWillEnter(() => {
        isViewActive.value = true;
        setHeader();
    });

    onIonViewWillLeave(() => {
        isViewActive.value = false;
        headerStore.setDefaultHeaderDefinition();
    });

    setHeader();

    const updateHeaderTitle = (title: string) => {
        if (isViewActive.value) {
            headerStore.headerDefinition.title = title;
        }
    };

    return { updateHeaderTitle };
};